import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router';
import { LoggedOutLayout } from 'containers';
import { PasswordResetRequestForm, Card, SecondaryButton, Spinner } from 'components';
import { LLSubmitButton } from '../../components/FormElements';
import { requestPasswordReset } from 'redux/modules/auth';
var PasswordResetRequest = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    theme: state.theme
  };
}, {
  requestPasswordReset: requestPasswordReset
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PasswordResetRequest, _Component);

  var _super = _createSuper(PasswordResetRequest);

  function PasswordResetRequest(props) {
    var _this;

    _classCallCheck(this, PasswordResetRequest);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "submitResetRequest", function (data) {
      _this.setState({
        requestingReset: true
      });

      return _this.props.requestPasswordReset(data).then(_this.resetRequestSuccess)["catch"](_this.resetRequestFail);
    });

    _defineProperty(_assertThisInitialized(_this), "resetRequestSuccess", function () {
      _this.setState({
        requestingReset: false,
        resetRequested: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resetRequestFail", function (err) {
      console.error(err);

      _this.setState({
        requestingReset: false,
        requestError: err
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentScreen", function () {
      if (!_this.state.requestingReset && !_this.state.resetRequested && !_this.state.requestError) {
        return /*#__PURE__*/React.createElement(PasswordResetRequestForm, {
          onSubmit: _this.submitResetRequest
        });
      }

      var innerContent = /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 305
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'block',
          margin: '10px 0'
        }
      }, "You will receive an email shortly with a link to reset your password"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
        to: "/login"
      }, /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Return to login"
      })));

      if (_this.state.requestingReset) {
        innerContent = /*#__PURE__*/React.createElement("div", {
          style: {
            position: 'relative',
            minHeight: '100px'
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "row center-xs middle-xs",
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Card, {
        className: "col-xs-12 col-sm-6 col-md-4"
      }, /*#__PURE__*/React.createElement("img", {
        src: _this.props.theme.logo,
        style: {
          maxWidth: 300
        },
        alt: "Likeable Local Password Reset Request"
      }), /*#__PURE__*/React.createElement("br", null), innerContent));
    });

    _this.state = {
      requestingReset: false,
      resetRequested: false,
      requestError: null
    };
    return _this;
  }

  _createClass(PasswordResetRequest, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showBg: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Password Reset Request"
      }), this.getCurrentScreen());
    }
  }]);

  return PasswordResetRequest;
}(Component), _defineProperty(_class2, "propTypes", {}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object
}), _temp)) || _class);
export { PasswordResetRequest as default };